/* eslint-disable react-hooks/exhaustive-deps */
import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ICONS from "../../../../assets/Icons";
import CommonAlertCard from "../../../../components/_utils/CommonAlertCard/index.jsx";
import CommonBankLogo from "../../../../components/_utils/CommonBankLogo";
import Chips from "../../../../components/_utils/CommonButtons/Chips/index.jsx";
import SwitcherTabs from "../../../../components/_utils/CommonButtons/SwitcherTabs";
import TopNavSmallButton from "../../../../components/_utils/CommonButtons/TopNavSmallButton";
import CommonContainerCard from "../../../../components/_utils/CommonContainerCard/index.jsx";
import CommonDetailCard from "../../../../components/_utils/CommonDetailCard/index.jsx";
import CommonInfoBox from "../../../../components/_utils/CommonInfoBox";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import SmallPopupWithBulletPoints from "../../../../components/_utils/CommonSmallPopupWithBulletPoint/index.jsx";
import CommonToast from "../../../../components/_utils/CommonToast";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import MediumImagePopup from "../../../../components/_utils/MediumImagePopup";
import RecreatePromptModalPopup from "../../../../components/_utils/RecreatePromptModalPopup";
import TimelineStatusBar from "../../../../components/_utils/TimelineCommonComponents/TimelineStatusBar";
import TimelinePopupContent from "../../../../components/_utils/TimelinePopupContent";
import TitleSubtitlePair from "../../../../components/_utils/TitleSubtitlePair";
import BeneTxnDeclinePopup from "../../../../components/_utils/TransactionCommonComponents/CommonDeclinePopups/BeneTxnDeclinePopup";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast";
import BeneficiaryAccountDetailsPopup from "../../../../components/Accounts/BeneficiaryAccount/BeneficiaryAccountDetailsPopup/index.jsx";
import OwnerAccountDetailsPopUp from "../../../../components/Accounts/OwnerAccount/OwnerAccountDetailsPopUp/index.jsx";
import CommonTimeLineCard, {
  addLifeCycleStatus,
} from "../../../../components/CommonTimeLineCard";
import Loader from "../../../../components/Loader/Index";
import useRestrictedAction from "../../../../hooks/useRestrictedAction.js";
import { disableSwitcher } from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import {
  beneficiaryTransactionsActionable,
  beneficiaryTransactionsAddLabel,
  beneficiaryTransactionsApprove,
  beneficiaryTransactionsDetailsById,
  beneficiaryTransactionsReject,
  beneficiaryTransactionsRemoveLabel,
} from "../../../../redux/features/transactions/beneficiaryTransactions/index.js";
import {
  getOutsideBankingHoursLabel,
  isOutsideBankingHours,
} from "../../../../utils/bankingHours.js";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../../utils/configurationProvider";
import formatCurrency from "../../../../utils/CurrencyFormater";
import formatDateViewAll from "../../../../utils/formatDateViewAll";
import globalText from "../../../../utils/globalText";
import ISO_DataFormatter from "../../../../utils/ISO_DataFormatter";
import useCategories from "../../../../utils/useCategories";
import BeneficiaryTransactionViewall from "../BeneficiaryTransactionViewall";
import "./index.css";

const BeneficiaryTransactionDetails = ({
  bene_txn_id,
  closeBeneTxnDetailModal,
  type,
  setTransactionFilterData,
  setTransactionFilterID,
  typeMulti,
  typeSingle,
}) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const previousStatus = useLocation()?.state?.options?.state;
  const { typeSingleMob } = location.state || {};

  const cardRefs = useRef({});
  const cardRefsDist = useRef({});
  const leftContentRef = useRef(null);
  const labelActionDispatchedRef = useRef(false);
  const categoryMapper = useCategories();

  const [labels, setLabels] = useState([]);
  const [prevIndex, setPrevIndex] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );
  const [, setRightHeight] = useState("auto");
  const [entityId, setEntityId] = useState("");
  const [loading, setLoading] = useState(true);
  const [, setInputDisabled] = useState(false);
  const [infoBox, setInfoBox] = useState(false);
  const [modalType, setModalType] = useState("");
  const [btnClicked, setbtnClicked] = useState({});
  const [isAccName, setIsAccName] = useState(false);
  const [copiedField, setCopiedField] = useState("");
  const [loadingBox, setLoadingBox] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [labelDetails, setLabelDetails] = useState([]);
  const [selectedImage, setSelectedImage] = useState({});
  const [networkError, setNetworkError] = useState(false);
  const [openImageUrl, setOpenImageUrl] = useState(false);
  const [animationClass, setAnimationClass] = useState("");
  const [txnDetailsData, setTxnDetailsData] = useState([]);
  const [isCategoryName, setIsCategoryName] = useState(false);
  const [OwnerDetailpop, setOwnerDetailpop] = useState(false);
  const [beneTxnDetailsID, setBeneTxnDetailsID] = useState("");
  const [showLabelsPopup, setShowLabelsPopup] = useState(false);
  const [openTransHistory, setOpenTransHistory] = useState(false);
  const [checkTransaction, setCheckTransaction] = useState(false);
  const [showDeclineModal, setShowDeclineModal] = useState(false);
  const [showRecreateModal, setShowRecreateModal] = useState(false);
  const [opentimelinepopup, SetopenTimelinePopup] = useState(false);
  const [labelPopupLoading, setLabelPopupLoading] = useState(false);
  const [showAssignedLabels, setShowAssignedLabels] = useState(false);
  const [openApprovalTimeline, setOpenApprovalTimeline] = useState([]);
  const [beneAccountDetailpop, setBeneAccountDetailpop] = useState(false);
  const [approvalNotPermitted, setApprovalNotPermitted] = useState(false);
  const [showApprovalTimeline, setShowApprovalTimeline] = useState(false);
  const [showBankingHoursPopup, setShowBankingHoursPopup] = useState(false);
  const [openDistributionTimeline, setOpenDistributionTimeline] = useState([]);
  const [showDistributionTimeline, setShowDistributionTimeline] =
    useState(false);
  const [showDetails, setShowDetails] = useState(
    typeSingle === "Additional_Details" ||
      typeSingleMob === "Additional_Details" ||
      typeMulti === "MultiApproval_Session_Data"
      ? false
      : true,
  );
  const [showAdditionalDetails, setShowAdditionalDetails] = useState(
    typeSingle === "Additional_Details" ||
      typeMulti === "MultiApproval_Session_Data" ||
      typeSingleMob === "Additional_Details"
      ? true
      : false,
  );
  const [index, setIndex] = useState(
    showDetails
      ? GlobalConfiguration?.lengthCheckZero
      : showAdditionalDetails
        ? GlobalConfiguration?.lengthCheckOne
        : showAssignedLabels
          ? GlobalConfiguration?.lengthCheckTwo
          : GlobalConfiguration?.lengthCheckZero,
  );

  const resetAllTimelines = () => {
    setOpenApprovalTimeline(
      new Array(
        txnDetailsData?.[GlobalConfiguration.lengthCheckZero]?.logs?.length ||
          GlobalConfiguration.lengthCheckZero,
      ).fill(false),
    );

    setOpenDistributionTimeline(
      new Array(
        txnDetailsData?.[GlobalConfiguration.lengthCheckZero]?.distribution_logs
          ?.length || 0,
      ).fill(false),
    );
  };

  const { services } = useSelector((state) => state.refreshToken);
  const { beneficiaryTransactionsDetailsData } = useSelector(
    (state) => state.beneficiaryTransactions,
  );
  const loginid = JSON.parse(sessionStorage.getItem("response"));

  const transactionData = beneficiaryTransactionsDetailsData?.transaction?.[0];

  const transactionId = txnDetailsData?.[0]?.txn_id;

  const isOutsideBankingHoursNow = isOutsideBankingHours();

  const hasApprovalService = services?.includes("ABeneficiaryTxn");

  const isTransactionPendingOutsideBankingHours =
    hasApprovalService &&
    txnDetailsData?.[0]?.lifecycle_status === "pending" &&
    isOutsideBankingHoursNow;

  const isAccountApprovalPendingOutsideBankingHours =
    hasApprovalService &&
    txnDetailsData?.[0]?.beneficiary_account_approval_status === "pending" &&
    isOutsideBankingHoursNow;

  const shouldShowBankingHoursAlert =
    isTransactionPendingOutsideBankingHours ||
    isAccountApprovalPendingOutsideBankingHours;

  const isTxnDetailPopup = type === "bene_txn_detail_modal";

  const hasConfidential = services?.includes("VConfidentialTxn");
  const hasCreateService = services?.includes("CBeneficiaryTxn");

  const beneAccountId = transactionData?.beneficiary_account_id;
  const beneAccountStatus =
    transactionData?.beneficiary_account_approval_status;

  const isFurtherApprovalPending =
    txnDetailsData?.[0]?.lifecycle_status === "pending" &&
    txnDetailsData?.[0]?.approved === "N" &&
    txnDetailsData?.[0]?.logs[
      txnDetailsData?.[0]?.logs.length - GlobalConfiguration.lengthCheckOne
    ]?.action?.toLowerCase() === "approved" &&
    txnDetailsData?.[0]?.logs[
      txnDetailsData?.[0]?.logs.length - GlobalConfiguration.lengthCheckOne
    ]?.user_id === loginid?.employees?.id;

  const categoryIcon = categoryMapper(
    transactionData?.category_id?.category_id,
  );

  const { showRestrictedAction, RestrictedActionPopup } = useRestrictedAction();

  useLayoutEffect(() => {
    if (index !== prevIndex) {
      const direction =
        index > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setPrevIndex(index);
    }
  }, [index]);

  const PopupcloseIcons = () => {
    resetAllTimelines();
    SetopenTimelinePopup(false);
    setShowApprovalTimeline(false);
    setShowDistributionTimeline(false);
  };

  const actionRestricted = () => {
    showRestrictedAction({
      path: `/beneficiary_transaction_dashboard/beneficiary_transaction_view_all/beneficiary_transaction_detail_page/${id ?? bene_txn_id}`,
    });
  };
  const handleBeneAccountClick = () => {
    if (isTxnDetailPopup) {
      actionRestricted();
      return;
    }

    if (!services.includes("BVAccount")) {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "BVAccount" },
      });
      return;
    }
    setBeneAccountDetailpop(true);
  };

  const labelTxnIds = [beneTxnDetailsID || id || bene_txn_id].filter(Boolean);

  const handleTimelinePopup = () => {
    if (isTxnDetailPopup) {
      actionRestricted();
    } else {
      SetopenTimelinePopup(true);
      setShowApprovalTimeline(true);
      if (!showApprovalTimeline) {
        setShowDetails(true);
        setShowAdditionalDetails(false);
        setShowDistributionTimeline(false);
        setShowAssignedLabels(false);
      }
      setOpenDistributionTimeline(false);
    }
  };

  const openTransactionHistory = () => {
    setOpenTransHistory(true);
  };

  const closeTransactionHistory = () => {
    setOpenTransHistory(false);
  };

  const toggleDetails = () => {
    setIndex(GlobalConfiguration?.lengthCheckZero);
    setShowDetails(true);
    setShowAdditionalDetails(false);
    setShowAssignedLabels(false);
  };

  const toggleAdditionalDetails = () => {
    setIndex(GlobalConfiguration?.lengthCheckOne);
    setShowAdditionalDetails(true);
    setShowDetails(false);
    setShowAssignedLabels(false);
  };

  const toggleAssignedLabels = () => {
    setIndex(GlobalConfiguration?.lengthCheckTwo);
    setShowAssignedLabels(true);
    setShowAdditionalDetails(false);
    setShowDetails(false);
  };

  const handleApproveTransaction = async (id) => {
    setbtnClicked((prev) => ({
      ...prev,
      [transactionId]: "Approve",
    }));
    UniversalRefreshToast("Approving transaction");
    setTimeout(() => {
      toast.dismiss();
    }, IntervalConfiguration?.intervalMedium);

    const txnId = isTxnDetailPopup ? bene_txn_id : id;

    const res = await dispatch(
      beneficiaryTransactionsApprove({
        id: txnId,
      }),
    );

    if (res?.payload === undefined) {
      setNetworkError(
        "An error occured while taking action on this transaction",
      );
      setTimeout(() => {
        CommonToast({
          text: "An error occured while taking action on this transaction",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }, 2000);
    } else if (res?.payload?.errors?.user_unauthorized?.[0]) {
      setTimeout(() => {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "VBeneficiaryTxn",
          },
        });
      }, 2000);
    } else if (
      res?.payload?.status === false ||
      res.type === "beneficiaryTransactionsReject/rejected"
    ) {
      if (
        res?.payload?.errors?.base[0]?.errors &&
        res?.payload?.errors?.base[0]?.errors[0]?.reason
      ) {
        const errorMsg = res?.payload?.errors?.base[0]?.errors[0]?.reason;
        if (!Array.isArray(errorMsg)) {
          setErrorMessage(errorMsg);
          setTimeout(() => {
            CommonToast({
              text: errorMsg,
              icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
              variant: "var(--error)",
              buttonNeeded: false,
            });
          }, IntervalConfiguration?.intervalMedium);
        } else {
          setErrorMessage(res.payload.errors.base[0].errors[0].reason[0]);
          if (
            res.payload.errors.base[0].errors[0].reason.length >=
            GlobalConfiguration?.lengthCheckOne
          ) {
            let msgs = res.payload.errors.base[0].errors[0].reason;
            msgs.forEach((error) => {
              if (res?.payload?.status === false) {
                setTimeout(() => {
                  CommonToast({
                    text: error,
                    icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                    variant: "var(--error)",
                    buttonNeeded: false,
                  });
                }, IntervalConfiguration?.intervalMedium);
              }
            });
          }
        }
      } else if (
        res?.payload?.errors?.base[0]?.reason &&
        res?.payload?.errors?.base[0]?.reason[0]
      ) {
        setErrorMessage(res?.payload?.errors?.base[0]?.reason[0]);
        setTimeout(() => {
          CommonToast({
            text: res?.payload?.errors?.base[0]?.reason[0],
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        }, IntervalConfiguration?.intervalMedium);
      } else if (res?.payload?.errors?.base[0]) {
        setErrorMessage(res.payload.errors.base[0]);
        setTimeout(() => {
          CommonToast({
            text: res.payload.errors.base[0],
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        }, IntervalConfiguration?.intervalExtraLarge);
      }
    } else {
      // const approvedLifecycle =
      //   res?.payload?.transactions?.[GlobalConfiguration.lengthCheckZero]
      //     ?.lifecycle_status;
      // const approvedDistributionFromRes =
      //   res?.payload?.transactions?.[GlobalConfiguration.lengthCheckZero]
      //     ?.distribution_lifecycle_status;

      // const approvedDistribution =
      //   approvedDistributionFromRes ??
      //   (approvedLifecycle === "approved" ? "created" : undefined);

      // const updatedData = beneficiaryTransactionsDetailsData?.transaction?.map(
      //   (data) => {
      //     const resolvedLifecycle = approvedLifecycle ?? data?.lifecycle_status;
      //     const resolvedDistribution =
      //       approvedDistribution ?? data?.distribution_lifecycle_status;

      //     const uiState = addLifeCycleStatus({
      //       lifecycle_status: resolvedLifecycle,
      //       distribution_lifecycle_status: resolvedDistribution,
      //       services,
      //     });

      //     return {
      //       ...data,
      //       lifecycle_status: resolvedLifecycle,
      //       distribution_lifecycle_status: resolvedDistribution,
      //       last_updated_status:
      //         res?.payload?.transactions?.[GlobalConfiguration.lengthCheckZero]
      //           ?.last_updated_status,
      //       last_updated_user_id:
      //         res?.payload?.transactions?.[GlobalConfiguration.lengthCheckZero]
      //           ?.last_updated_user_id,
      //       ...uiState,
      //     };
      //   },
      // );
      await dispatch(
        beneficiaryTransactionsDetailsById({
          id: isTxnDetailPopup ? bene_txn_id : id,
        }),
      );
      if (res?.payload?.status === true) {
        setTimeout(() => {
          CommonToast({
            text: "Transaction approved successfully.",
            icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
            variant: "var(--success)",
          });
        }, 1000);
        if (typeMulti === "MultiApproval_Session_Data") {
          let storedData = JSON.parse(sessionStorage.getItem("selectedData"));

          if (storedData) {
            const updatedTransactions =
              storedData.selectedSendTransactions.filter(
                (transaction) => transaction.txn_id !== bene_txn_id,
              );
            const updatedTransactionsId =
              storedData.selectedTransactions.filter(
                (transaction) => transaction !== bene_txn_id,
              );

            sessionStorage.setItem(
              "selectedData",
              JSON.stringify({
                ...storedData,
                selectedSendTransactions: updatedTransactions,
                selectedTransactions: updatedTransactionsId,
              }),
            );
            setTransactionFilterData(updatedTransactions);
            setTransactionFilterID(updatedTransactionsId);
          }
        }
      }
      if (isTxnDetailPopup) {
        setTimeout(() => {
          closeBeneTxnDetailModal();

          if (typeSingle === "Additional_Details") {
            window.location.reload();
          }
        }, IntervalConfiguration.intervalLarge);
      }
    }
    setbtnClicked((prev) => ({
      ...prev,
      [transactionId]: "none",
    }));
  };

  const handleDeclinedDetails = (id) => {
    setBeneTxnDetailsID(id);
    setShowDeclineModal(true);
  };

  const handleRecreateDeclinedDetails = (id) => {
    setBeneTxnDetailsID(id);
    setShowRecreateModal(true);
  };

  const closeDeclineModal = () => {
    setShowDeclineModal(false);
    setbtnClicked((prev) => ({
      ...prev,
      [transactionId]: "none",
    }));
  };

  const closeBeneAccountDetailModal = () => {
    setBeneAccountDetailpop(false);
  };

  const updateAllAccounts = (updatedAccounts) => {
    setTxnDetailsData(updatedAccounts);
  };

  const showAmountInfo = () => {
    setInfoBox(!infoBox);
  };

  const closeModal = () => {
    if (infoBox || showDeclineModal) {
      setInfoBox(false);
      setShowDeclineModal(false);
    }
  };

  const additionalData = transactionData?.additional_data;

  const validItems = additionalData?.data ? additionalData?.data : [];
  const attachments = validItems.filter(
    (obj) =>
      (obj.data_type.toLowerCase() === "hyperlink" ||
        obj.data_type === "File" ||
        obj.data_type === "upload") &&
      "value" in obj,
  );

  const handleDistributionClick = () => {
    if (isTxnDetailPopup) {
      actionRestricted();
    } else {
      SetopenTimelinePopup(true);
      setShowDistributionTimeline(true);

      if (!showDistributionTimeline) {
        setShowDetails(true);
        setShowAdditionalDetails(false);
        setShowApprovalTimeline(false);
        setShowAssignedLabels(false);
      }
      setOpenApprovalTimeline(false);
    }
  };

  const handleRecreationConfirmation = (reason) => {
    (async () => {
      setInputDisabled(true);
      const response = await dispatch(
        beneficiaryTransactionsReject({
          id: id ?? bene_txn_id,
          reason: reason,
        }),
      );
      if (beneficiaryTransactionsReject.fulfilled.match(response)) {
        CommonToast({
          text: "Transaction rejected and sent for recreation.",
          icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
        });
        await fetchData();
        setNetworkError(null);
        setErrorMessage(null);
        setShowRecreateModal(false);
      } else {
        if (
          response?.payload?.errors?.base?.[0]?.errors &&
          response.payload.errors.base[0].errors[0]
        ) {
          if (
            response.payload.errors.base[0].errors.length >=
            GlobalConfiguration?.lengthCheckOne
          ) {
            const msg1 = response.payload.errors.base[0].errors;

            if (response.payload.status === false) {
              msg1.forEach((error1) => {
                setTimeout(() => {
                  CommonToast({
                    text: error1,
                    icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                    variant: "var(--error)",
                    buttonNeeded: false,
                  });
                }, IntervalConfiguration?.intervalMedium);
              });
            }
          }
        } else if (response?.payload?.errors?.base?.[0]) {
          const fallbackErrorMessage = response.payload.errors.base[0];
          CommonToast({
            text: fallbackErrorMessage,
            icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        }
        setShowRecreateModal(false);
        setInputDisabled(false);
      }
    })();
  };

  const handleApprovalTimeline = (index) => {
    setOpenApprovalTimeline((prevOpenDivs) => {
      if (!Array.isArray(prevOpenDivs)) {
        return [];
      }
      const newOpenDivs = [...prevOpenDivs];
      newOpenDivs[index] = !newOpenDivs[index];
      return newOpenDivs;
    });
    setOpenDistributionTimeline(
      Array(txnDetailsData?.[0]?.distribution_logs?.length).fill(false),
    );
    if (!openApprovalTimeline[index]) {
      setTimeout(() => {
        cardRefs.current[index]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, IntervalConfiguration.intervalExtraSmall);
    }
  };

  const handleDistributionTimeline = (index) => {
    setOpenDistributionTimeline((prevOpenDivs) => {
      if (!Array.isArray(prevOpenDivs)) {
        return [];
      }
      const newOpenDivs = [...prevOpenDivs];
      newOpenDivs[index] = !newOpenDivs[index];
      return newOpenDivs;
    });
    setTimeout(() => {
      if (cardRefsDist.current[index]) {
        cardRefsDist.current[index].scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, IntervalConfiguration.intervalExtraSmall);
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message;
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLabelPopupLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds = toArray(labelTxnIds);
    const res = await dispatch(
      beneficiaryTransactionsAddLabel({
        record_ids: recordIds,
        labels: labelsToAssign,
      }),
    );
    if (beneficiaryTransactionsAddLabel?.fulfilled?.match(res)) {
      toast.dismiss();

      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
      });

      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
      toggleAssignedLabels();
      await fetchData();
    }
    if (beneficiaryTransactionsAddLabel?.rejected?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
      });
    }
    setLabelPopupLoading(false);
    if (beneficiaryTransactionsAddLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLabelPopupLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(labelTxnIds);
    const res = await dispatch(
      beneficiaryTransactionsRemoveLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );
    if (beneficiaryTransactionsRemoveLabel?.fulfilled?.match(res)) {
      toast.dismiss();

      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
      });
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
      toggleAssignedLabels();
      await fetchData();
    }

    if (beneficiaryTransactionsRemoveLabel?.rejected?.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
      });
    }
    setLabelPopupLoading(false);
    if (beneficiaryTransactionsRemoveLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const fetchData = useCallback(async () => {
    setLoading(true);

    try {
      const txnId = isTxnDetailPopup ? bene_txn_id : id;

      const response = await dispatch(
        beneficiaryTransactionsDetailsById({
          id: txnId,
        }),
      );

      if (beneficiaryTransactionsDetailsById.fulfilled.match(response)) {
        setLabelDetails(response.payload?.transaction?.[0]?.labels || []);

        setLabels(response.payload?.summary?.available_labels || []);
      }
      if (response?.payload?.status === 404) {
        navigate("*");
      }
    } catch (error) {
      console.error("Failed to load the transaction details", error);
    } finally {
      setLoading(false);
    }
  }, [dispatch, isTxnDetailPopup, bene_txn_id, id, navigate]);

  useEffect(() => {
    dispatch(disableSwitcher());
    // The next lines are commented out as a deliberate reminder to not re
    // enable the switcher when exiting this page since it will be re enabled by
    // whereever one may navigate anyways

    // return () => {
    //   dispatch(enableSwitcher());
    // }
  }, []);

  // useEffect(() => {
  //   let availableLabels = sessionStorage?.getItem("beneficiaryTxnLabels");
  //   const parsedLabels = JSON?.parse(availableLabels);
  //   setLabels(parsedLabels);
  // }, []);

  const handleClose = () => {
    setShowLabelsPopup(false);

    if (!labelActionDispatchedRef.current) return;

    labelActionDispatchedRef.current = false;
    toggleAssignedLabels();
  };

  useEffect(() => {
    if (beneficiaryTransactionsDetailsData) {
      const uiState = addLifeCycleStatus({
        lifecycle_status: transactionData?.lifecycle_status,
        distribution_lifecycle_status:
          transactionData?.distribution_lifecycle_status,
        services,
        previousStatus,
        checkTransaction,
      });

      const newData = beneficiaryTransactionsDetailsData?.transaction?.map(
        (account) => ({
          ...account,
          loading: false,
          error: false,
          message: "",
          last_updated_user_id_check: false,
          ...uiState,
        }),
      );

      setTxnDetailsData(newData);

      const newEntityId = transactionData?.entity_id;
      const newTxnId = transactionData?.txn_id;

      if (entityId !== newEntityId) {
        setEntityId(newEntityId);
      }

      if (beneTxnDetailsID !== newTxnId) {
        setBeneTxnDetailsID(newTxnId);
      }
    }
  }, [
    beneficiaryTransactionsDetailsData,
    checkTransaction,
    previousStatus,
    services,
  ]);

  useEffect(() => {
    const targetId = id ?? bene_txn_id;

    const checkTxnActionable = async () => {
      if (!entityId || !beneTxnDetailsID) return;

      if (targetId && beneTxnDetailsID !== targetId) return;

      const isPendingWithApprovalService =
        transactionData?.lifecycle_status === "pending" &&
        services?.includes("ABeneficiaryTxn");

      if (!isPendingWithApprovalService) {
        setCheckTransaction(false);
        return;
      }

      setLoadingBox(true);
      try {
        const response = await dispatch(
          beneficiaryTransactionsActionable({
            entityId: entityId,
            txn_id: [beneTxnDetailsID],
          }),
        );

        const transactionsData = response?.payload?.transactions || [];

        if (transactionsData.length === 0) {
          setCheckTransaction(false);
          setApprovalNotPermitted(true);
          return;
        }
        const transactionExists = transactionsData.some(
          (obj) => obj.txn_id === beneTxnDetailsID,
        );
        setCheckTransaction(transactionExists);
        setCheckTransaction(transactionExists);
      } catch (error) {
        setCheckTransaction(false);
      } finally {
        setLoadingBox(false);
      }
    };
    checkTxnActionable();
  }, [
    dispatch,
    entityId,
    beneTxnDetailsID,
    transactionData?.lifecycle_status,
    services,
    id,
    bene_txn_id,
  ]);

  useEffect(() => {
    setBeneTxnDetailsID("");
    setCheckTransaction(false);
    setApprovalNotPermitted(false);
  }, [id, bene_txn_id]);

  useEffect(() => {
    if (leftContentRef.current) {
      setRightHeight(leftContentRef.current.offsetHeight);
    }
  }, [txnDetailsData]);

  useEffect(() => {
    fetchData();
  }, [id]);

  return (
    <>
      <>{RestrictedActionPopup}</>

      {showBankingHoursPopup && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop bg-opacity-dark-opacity justify-center z-z-index-modal">
          <SmallPopupWithBulletPoints
            headerTitle="Why transaction cannot be processed?"
            headerFontWeight="semibold"
            headerFontColor="negative-act"
            textSize="font-md"
            bulletPoints={[
              `Any transaction created or approved after banking hours i.e. between ${getOutsideBankingHoursLabel()} will be processed on the next bank working day.`,
              "Payments are time-critical (e.g., salary, vendor payment, or bill payment), consider the possible processing delay before proceeding.",
            ]}
            closeIconImage={ICONS?.CLOSE}
            closeModal={() => setShowBankingHoursPopup(false)}
          />
        </div>
      )}
      {showLabelsPopup && (
        <div
          onClick={(e) => {
            e.stopPropagation();
            setShowLabelsPopup(true);
          }}
          className="fixed left-left-base w-width-full top-top-base h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal"
        >
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated transactions."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            LabelAccounts={labelTxnIds}
            isLabelPopupOpen={showLabelsPopup}
            filteredData={(
              beneficiaryTransactionsDetailsData?.transaction || []
            )
              ?.filter((t) => labelTxnIds.includes(t.txn_id))
              ?.map((t) => ({ ...t, id: t.txn_id }))}
            onClose={handleClose}
            loading={labelPopupLoading}
            setLoading={setLabelPopupLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
          />
        </div>
      )}
      {openImageUrl && (
        <>
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <MediumImagePopup
              image={selectedImage}
              closehandleFunction={() => {
                setOpenImageUrl(false);
              }}
            />
          </div>
        </>
      )}
      {opentimelinepopup && (
        <>
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <LargePopupRedirect
              headerTitle="Transaction timeline"
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              headertextSize="font-md"
              closeiconenabledBgColor="var(--primary-nav)"
              closeiconisLoading={false}
              closeiconhandleFunction={PopupcloseIcons}
              closeicon={ICONS?.CLOSE}
              closeiconhoverOption="white"
              closeiconbtnType={"button"}
              closeiconisDisabled={false}
              closeicondisabledBgColor={""}
              closeiconbuttonRef={null}
              closeicontitle={"Close"}
              btnType={"button"}
              handleFunction={() => {}}
              enabledBgColor={"var(--positive-act)"}
              hoverOption={"dark"}
              outLineColor={""}
              enabledTextColor={"var(--text-primary)"}
              fullWidthRequired={false}
              isDisabled={false}
              disabledTextColor={""}
              disabledBgColor={""}
              isLoading={false}
              buttonRef={null}
              inActiveVariantNeeded={false}
              isLoaderNeeded={false}
              isscrollRequired={true}
            >
              <TimelinePopupContent
                logsData={txnDetailsData}
                handleApprovalClick={handleTimelinePopup}
                handleDistributionClick={handleDistributionClick}
                showDistributionRightIcon={false}
                showApprovalLeftIcon={false}
                showApprovalTimeline={showApprovalTimeline}
                showDistributionTimeline={showDistributionTimeline}
                openApprovalTimeline={openApprovalTimeline}
                openDistributionTimeline={openDistributionTimeline}
                handleApprovalTimeline={handleApprovalTimeline}
                handleDistributionTimeline={handleDistributionTimeline}
                setOpenDistributionTimeline={setOpenDistributionTimeline}
                setOpenApprovalTimeline={setOpenApprovalTimeline}
                cardType={"double"}
                popUpMode={true}
              />
            </LargePopupRedirect>
          </div>
        </>
      )}
      {showRecreateModal && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <RecreatePromptModalPopup
            onConfirmBtnClick={handleRecreationConfirmation}
            onClose={() => {
              setShowRecreateModal(false);
            }}
            onCancelBtnClick={() => {
              setShowRecreateModal(false);
            }}
          />
        </div>
      )}

      {showDeclineModal && (
        <BeneTxnDeclinePopup
          handleClose={closeDeclineModal}
          txnId={beneTxnDetailsID}
          allTxnData={txnDetailsData}
          updateAllTxn={updateAllAccounts}
          onRejectSuccess={() => {
            if (isTxnDetailPopup) {
              closeDeclineModal();
              window.location.reload();
            }
          }}
        />
      )}

      {beneAccountDetailpop && (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <BeneficiaryAccountDetailsPopup
            closeBeneAccountDetailModal={closeBeneAccountDetailModal}
            bene_account_id={beneAccountId}
            beneAccountStatus={beneAccountStatus}
            type={"bene_account_detail_modal"}
          />
        </div>
      )}

      {OwnerDetailpop && (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-Primary-black bg-opacity-dark-opacity">
          <OwnerAccountDetailsPopUp
            closeBeneAccountDetailModal={() => {
              setOwnerDetailpop(false);
            }}
            Remibursement_owneraccount_id={transactionData?.owner_account_id}
            type={"reimburseowner_details"}
          />
        </div>
      )}

      {openTransHistory && (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <LargePopupRedirect
            headerTitle={
              modalType === "Confidential transaction"
                ? "Confidential transaction"
                : "Transaction history"
            }
            headersubtext={
              modalType === "Confidential transaction"
                ? "All confidential transactions related to the beneficiary are listed below."
                : "All transactions related to the beneficiary are listed below."
            }
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={() => closeTransactionHistory()}
            closeicon={ICONS?.CLOSE}
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            enabledBgColor={"var(--negative-act)"}
            hoverOption={"dark"}
            outLineColor={""}
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            isDisabled={false}
            disabledTextColor={""}
            disabledBgColor={""}
          >
            <BeneficiaryTransactionViewall
              openTransHistory={openTransHistory}
              bene_account_name={
                isAccName ||
                isCategoryName ||
                modalType === "Confidential transaction"
                  ? transactionData?.beneficiary_account_name
                  : ""
              }
              bene_account_id={
                isAccName ||
                isCategoryName ||
                modalType === "Confidential transaction"
                  ? transactionData?.beneficiary_account_id
                  : ""
              }
              bene_account_confidential={
                isCategoryName
                  ? null
                  : modalType === "Confidential transaction"
                    ? transactionData?.confidential_transaction
                    : null
              }
              onClose={closeTransactionHistory}
              typepop={"txnHistorypopup"}
              popup={modalType}
              category={isCategoryName ? transactionData?.category_id : ""}
              label={{
                ...(isAccName
                  ? { label: "accountName" }
                  : isCategoryName
                    ? { label: "categoryName" }
                    : {}),
              }}
            />
          </LargePopupRedirect>
        </div>
      )}
      <div
        className={`bg-primary-bg overflow-x-hidden ${showDeclineModal || openTransHistory ? "overflow-y-hidden" : "overflow-y-scroll"}`}
        style={{
          height: isTxnDetailPopup
            ? "var(--height-full)"
            : "var(--full-height)",
        }}
        onClick={closeModal}
      >
        {loading ? (
          <div
            className={`h-full m-auto justify-center items-center flex ${isTxnDetailPopup ? "" : "pt-padding-xl"}`}
          >
            <Loader />
          </div>
        ) : (
          <>
            {!isTxnDetailPopup && (
              <div className="Qsmd:flex hidden h-navbar-breadcrumb-height bg-primary-nav w-width-full"></div>
            )}

            <div
              className={`fixed top-top-base left-left-base mt-margin-base w-width-full z-z-index-header bg-primary-nav shadow-box-shadow-bottom block ${
                isTxnDetailPopup ? "hidden" : "lg:hidden"
              }`}
            >
              <TopNavComponent
                topNavHeader={globalText?.BENEFICIARY}
                topNavSubText={globalText?.TRANSACTION_DETAILS}
                isFormattingNotRequired={true}
              />
            </div>
            <div
              className={`h-auto w-width-full bg-primary-nav ${isTxnDetailPopup ? "pt-padding-base" : "Qsmd:pt-padding-base pt-padding-lg"} `}
            >
              <div
                className={`bene-txn-account-primary-details ${isTxnDetailPopup ? "" : "Qsmd:pt-padding-base pt-padding-lg"}`}
              >
                {beneficiaryTransactionsDetailsData?.transaction?.map(
                  (account) => (
                    <div
                      key={account.txn_id}
                      className="w-width-full h-auto bg-primary-nav"
                    >
                      <div className="flex flex-col lg:flex-row border-b border-solid border-primary-bg  mx-margin-md lg:mx-margin-base">
                        <div
                          className={`${isTxnDetailPopup ? "lg:w-width-md" : "lg:w-width-md w-auto"} Qlg:px-padding-base justify-between flex flex-row gap-x-gap-sm items-center py-padding-md pl-padding-base  px-padding-base  Qlg:flex-shrink-0 flex-1`}
                        >
                          <div className="flex flex-col gap-y-gap-xs lg:pl-padding-sm">
                            <div className="flex gap-x-gap-xs relative">
                              <div>
                                <TitleSubtitlePair
                                  title={`INR ${formatCurrency(account.total_amount)}`}
                                  titleColor="settled"
                                  subtitle="Amount"
                                  info={true}
                                  onClick={showAmountInfo}
                                  alignRight={false}
                                  hoverOption="white"
                                  isBold={true}
                                  variant="md"
                                />
                              </div>

                              {infoBox && (
                                <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
                                  <CommonInfoBox
                                    headerTitle="Amount Breakdown"
                                    transactionAmount={account.total_amount}
                                    transactionAmountColor={"settled"}
                                    transactionLabel="Transaction amount"
                                    finalAmountLabel="Amount credited"
                                    rows={[
                                      {
                                        label: "Amount debited",
                                        value: account.total_amount,
                                        icon: ICONS?.SUBTRACTION_WITH_ROUNDNESS,
                                      },
                                      {
                                        label: "Tax amount",
                                        value: account.tax_amount,
                                        icon: ICONS?.SUBTRACTION_WITH_ROUNDNESS,

                                        operation: "subtract",
                                      },
                                      {
                                        label: "Payment charge",
                                        value: account.payment_charge,

                                        operation: "subtract",
                                      },
                                    ]}
                                    headerFontColor="text-primary"
                                    headerFontWeight="semibold"
                                    textSize="font-md"
                                    onClosepop={() => setInfoBox(null)}
                                    popupBgColor="primary-bg"
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="lg:mr-margin-sm flex justify-end pr-padding-sm gap-y-gap-xs text-right min-w-0 break-all flex-wrap">
                            <TitleSubtitlePair
                              isDisabled={false}
                              alignRight={true}
                              textAlign="right"
                              title={
                                account.distribution_utr
                                  ? account.distribution_utr
                                  : "N/A"
                              }
                              titleColor={"text-primary"}
                              subtitle={globalText?.UTR_NUMBER}
                              info={false}
                              showArrow={false}
                              isBold={false}
                              variant={"md"}
                            />
                          </div>
                        </div>

                        <div className="border-r border-solid border-primary-bg my-margin-md hidden lg:block"></div>
                        <div className="flex justify-between lg:justify-start gap-x-gap-md w-width-full lg:w-width-md py-padding-md Qlg:py-padding-md px-padding-base lg:px-padding-base border-t lg:border-none border-solid border-primary-bg flex-1">
                          <div className="gap-y-gap-xs lg:px-padding-md">
                            <div>
                              <TitleSubtitlePair
                                title={account.beneficiary_account_name}
                                titleColor="text-primary"
                                subtitle={globalText?.BENEFICIARY_NAME}
                                info={false}
                                alignRight={false}
                                hoverOption="white"
                                isBold={false}
                                variant="md"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="hidden lg:flex flex-col justify-end gap-gap-base min-h-[var(--positive-negative-btn-width)]">
                          <div className="flex items-center h-full">
                            <TopNavSmallButton
                              btnText={
                                <>
                                  {globalText?.TRANSACTION}
                                  <br />
                                  {globalText?.HISTORY}
                                </>
                              }
                              btnType="button"
                              icon={ICONS?.TRANSACTION_HISTORY}
                              handleFunction={() => {
                                setIsAccName(true);
                                setIsCategoryName(false);
                                if (isTxnDetailPopup) {
                                  actionRestricted();
                                } else {
                                  openTransactionHistory();
                                  setModalType("Transaction history");
                                }
                              }}
                              isDisabled={isTxnDetailPopup}
                              enabledTextColor="var(--text-primary)"
                              enabledBgColor="var(--primary-nav-act)"
                              disabledBgColor="var(--primary-nav-act)"
                              hoverOption="white"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="relative mx-margin-sm lg:mx-margin-base">
                        <div className="flex flex-col justify-between lg:flex-row lg:gap-gap-base h-auto lg:h-auto w-width-full">
                          <div
                            className={`flex flex-row pt-padding-sm w-width-full lg:w-width-md justify-between lg:h-height-md ${isTxnDetailPopup ? "lg:px-padding-base pr-padding-base pl-padding-base" : "lg:pl-padding-base pl-padding-base lg:pr-padding-base pr-padding-base "}`}
                          >
                            <div
                              className={`${
                                !services?.includes("VAccount") ||
                                isTxnDetailPopup
                                  ? "p-padding-base pl-padding-base"
                                  : ""
                              } `}
                            >
                              <TitleSubtitlePair
                                isDisabled={
                                  isTxnDetailPopup ||
                                  !services?.includes("VAccount")
                                    ? true
                                    : false
                                }
                                alignRight={false}
                                title={formatAccountNumber(
                                  account?.owner_account_bank_acc_no,
                                )}
                                titleColor={"text-primary"}
                                subtitle={globalText?.SOURCE_ACCOUNT}
                                onClick={() => {
                                  if (!services?.includes("VAccount")) {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "VAccount",
                                      },
                                    });
                                    return;
                                  }
                                  if (isTxnDetailPopup) {
                                    actionRestricted();
                                  } else {
                                    setOwnerDetailpop(true);
                                  }
                                }}
                                info={false}
                                showArrow={true}
                                hoverOption={"white"}
                                isBold={false}
                                variant={"md"}
                              />
                            </div>
                            <div className="bg-text-primary rounded-border-radius-md flex items-center justify-around h-toggle-btn-height px-padding-sm mt-margin-md lg:mr-margin-md mr-margin-sm Qlg:ml-margin-sm ">
                              <CommonBankLogo
                                ifsc={account.owner_account_ifsc_code}
                                variant="big"
                                type="pill"
                              />
                            </div>
                          </div>

                          <div className="flex items-center gap-gap-sm Qlg:px-padding-md Qlg:hidden mx-margin-sm Qlg:mx-margin-base">
                            <div className="w-width-md border-b border-primary-bg"></div>
                            <div className="w-icon-md">
                              <img
                                src={ICONS?.ARROW_DOWN_BLUE_WHITE}
                                alt="arrowDownBlueWhite"
                              />
                            </div>
                            <div className="w-width-md border-b border-primary-bg"></div>
                          </div>

                          <div
                            className={`border-r border-solid border-primary-bg h-auto my-margin-lg hidden lg:block ${isTxnDetailPopup ? "mt-margin-sm" : "mt-margin-md"}`}
                          ></div>
                          <div
                            className={`flex flex-row pt-padding-sm w-width-full lg:w-width-md justify-between lg:h-height-md lg:mb-margin-base mb-margin-sm ${isTxnDetailPopup ? "lg:px-padding-base pr-padding-base pl-padding-base" : "lg:pl-padding-base pl-padding-base  lg:pr-padding-base pr-padding-base"}`}
                          >
                            <div
                              className={`${
                                !services?.includes("VAccount") ||
                                isTxnDetailPopup
                                  ? "p-padding-base lg:pl-padding-sm pl-padding-base"
                                  : "lg:pl-padding-sm pl-padding-base"
                              } `}
                            >
                              <TitleSubtitlePair
                                isDisabled={isTxnDetailPopup ? true : false}
                                alignRight={false}
                                title={formatAccountNumber(
                                  account?.beneficiary_account_bank_acc_no,
                                )}
                                titleColor={"text-primary"}
                                subtitle={"Destination account"}
                                onClick={() => handleBeneAccountClick()}
                                info={false}
                                showArrow={true}
                                hoverOption={"white"}
                                isBold={false}
                                variant={"md"}
                              />
                            </div>
                            <div className="bg-text-primary rounded-border-radius-md flex items-center justify-around h-toggle-btn-height px-padding-sm mt-margin-md lg:mr-margin-md mr-margin-sm Qlg:ml-margin-sm">
                              <CommonBankLogo
                                ifsc={account.beneficiary_account_ifsc_code}
                                variant="big"
                                type="pill"
                              />
                            </div>
                          </div>

                          <div
                            className={`hidden lg:flex flex-col justify-end gap-gap-base min-h-[var(--positive-negative-btn-width)] ${
                              hasConfidential &&
                              beneficiaryTransactionsDetailsData?.transaction[0]
                                ?.confidential_transaction === "Y" &&
                              "border-b solid border-primary-bg"
                            }`}
                          >
                            <TopNavSmallButton
                              btnText={
                                transactionData?.category_id?.category_name
                              }
                              btnType="button"
                              isBackgroundRequired={true}
                              icon={categoryIcon?.url}
                              imgColor={categoryIcon?.colour}
                              handleFunction={() => {
                                setIsAccName(false);
                                setIsCategoryName(true);
                                setModalType("Transaction history");
                                if (isTxnDetailPopup) {
                                  actionRestricted();
                                } else {
                                  openTransactionHistory();
                                }
                              }}
                              isDisabled={isTxnDetailPopup}
                              enabledTextColor="var(--text-primary)"
                              enabledBgColor="var(--primary-nav-act)"
                              disabledBgColor="var(--primary-nav-act)"
                              hoverOption="white"
                              fullWidthRequired={false}
                            />
                          </div>
                        </div>
                      </div>

                      <div
                        className={`border-primary-bg border-solid border-t lg:border-b flex flex-col h-auto items-center justify-between lg:border-none lg:flex-col lg:px-padding-base lg:w-width-full mx-margin-md lg:mx-margin-base ${account?.beneficiary_account_approval_status === "pending" ? " border-primary-bg mx Qlg:border-none" : ""}`}
                      >
                        <div className="flex h-auto items-center justify-between lg:border-none lg:px-padding-base w-width-full">
                          <div className="w-width-full flex h-auto items-center justify-between lg:border-none lg:px-padding-base px-padding-base relative">
                            <div className="parent flex py-padding-md lg:py-padding-base w-full Qlg:w-width-md lg:justify-between justify-end gap-gap-sm">
                              <div className="lg:flex flex-col gap-y-gap-xs hidden mr-margin-xl lg:pl-padding-sm">
                                <TitleSubtitlePair
                                  isDisabled={false}
                                  alignRight={false}
                                  title={account?.owner_account_ifsc_code}
                                  titleColor={"text-primary"}
                                  subtitle={globalText?.IFSC_CODE}
                                  info={false}
                                  showArrow={false}
                                  isBold={false}
                                  variant={"md"}
                                />
                              </div>

                              <div className="lg:hidden payment flex flex-col gap-y-gap-xs item-start ml-margin-lg mr-margin-md">
                                <TitleSubtitlePair
                                  isDisabled={false}
                                  alignRight={false}
                                  title={
                                    account.distribution_mode_of_payment ||
                                    account.payment_method ||
                                    "N/A"
                                  }
                                  titleColor={"text-primary"}
                                  subtitle={globalText?.PAYMENT_METHOD}
                                  info={false}
                                  showArrow={false}
                                  isBold={false}
                                  variant={"md"}
                                />
                              </div>
                              <div className="payment hidden lg:flex flex-col gap-y-gap-xs items-end item-start ml-margin-lg mr-margin-md">
                                <TitleSubtitlePair
                                  isDisabled={false}
                                  alignRight={true}
                                  textAlign={"right"}
                                  title={
                                    account.distribution_mode_of_payment ||
                                    account.payment_method ||
                                    "N/A"
                                  }
                                  titleColor={"text-primary"}
                                  subtitle={globalText?.PAYMENT_METHOD}
                                  info={false}
                                  showArrow={false}
                                  isBold={false}
                                  variant={"md"}
                                />
                              </div>
                            </div>

                            <div className="border-primary-bg border-r border-solid hidden lg:block py-padding-md"></div>
                            <div
                              className="lg:flex justify-center items-center hidden z-z-index-content absolute bottom-stepper-gap-between"
                              style={{
                                left: "calc(var(--top-half) - var(--top-sm))",
                              }}
                            >
                              <img
                                src={ICONS?.ARROW_RIGHT_BLUE_WHITE}
                                className="w-icon-md h-icon-md"
                                alt="Transaction"
                              />
                            </div>
                            <div className="flex justify-between items-center gap-x-gap-md lg:gap-x-gap-xl pr-padding-md lg:pr-padding-base w-width-full lg:w-width-md">
                              <div className="hidden lg:flex flex-col justify-start items-start gap-y-gap-xs py-padding-sm mr-margin-xl ml-margin-md">
                                <TitleSubtitlePair
                                  isDisabled={false}
                                  alignRight={false}
                                  title={account.beneficiary_account_ifsc_code}
                                  titleColor={"text-primary"}
                                  subtitle={globalText?.IFSC_CODE}
                                  info={false}
                                  showArrow={false}
                                  isBold={false}
                                  variant={"md"}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="hidden lg:flex flex-col justify-end gap-gap-base min-h-[var(--positive-negative-btn-width)]">
                            {hasConfidential &&
                            transactionData?.confidential_transaction ===
                              "Y" ? (
                              <TopNavSmallButton
                                btnText={
                                  <>
                                    {globalText?.CONFIDENTIAL}
                                    <br />
                                    {globalText?.TRANSACTION}
                                  </>
                                }
                                btnType="button"
                                icon={ICONS?.CONFIDENTIAL_TRANSACTION}
                                handleFunction={() => {
                                  setIsCategoryName(false);
                                  setIsAccName(false);
                                  if (isTxnDetailPopup) {
                                    actionRestricted();
                                  } else {
                                    openTransactionHistory();
                                    setModalType("Confidential transaction");
                                  }
                                }}
                                isDisabled={isTxnDetailPopup}
                                enabledTextColor="var(--text-primary)"
                                enabledBgColor="var(--primary-nav-act)"
                                disabledBgColor="var(--primary-nav-act)"
                                hoverOption="white"
                                fullWidthRequired={false}
                              />
                            ) : (
                              <div className="bg-primary-nav-act w-positive-negative-btn-width h-[var(--topnav-small-btn-width)] invisible pointer-events-none"></div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ),
                )}
              </div>
            </div>

            <div className="bg-primary-bg lg:hidden block Qlg:border-none border-primary-bg">
              <div className="flex flex-col w-width-full max-w-tab-width-normal m-auto">
                <TimelineStatusBar
                  showMobile={true}
                  isLoading={loadingBox}
                  overrideAutoLoader
                  whichBtnClicked={btnClicked?.[transactionId] || "none"}
                  approvalNotPossible={
                    networkError || errorMessage || txnDetailsData?.[0]?.message
                  }
                  approvalNotPossibleIcon={true}
                  handleApprovalNotPossibleBtn={() => {
                    if (
                      services?.includes("ABeneficiaryTxn") &&
                      checkTransaction
                    ) {
                      handleRecreateDeclinedDetails(txnDetailsData.txn_id);
                    } else {
                      navigate("/feature_not_assigned", {
                        state: {
                          unavailableService: "ABeneficiaryTxn",
                        },
                      });
                    }
                  }}
                  isApprovalNotPossibleDisabled={false}
                  accountApprovalPending={
                    txnDetailsData?.[0]?.beneficiary_account_approval_status ===
                      "pending" &&
                    txnDetailsData?.[0]?.lifecycle_status === "pending"
                  }
                  accountApprovalPendingSubHeader={
                    services?.includes("BAAccount")
                      ? "Account is not approved, approve account before approving transaction."
                      : "To approve the account, please contact the authorized person."
                  }
                  handleApprovalPendingBtn={() =>
                    services?.includes("BAAccount")
                      ? setBeneAccountDetailpop(true)
                      : navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "BAAccount",
                          },
                        })
                  }
                  isApprovalPendingDisabled={!services?.includes("BAAccount")}
                  recreate={
                    txnDetailsData?.[0]?.lifecycle_status === "rejected"
                  }
                  recreateReason={
                    txnDetailsData?.[0]?.rejection_reason?.length > 150
                      ? txnDetailsData?.[0]?.rejection_reason.slice(0, 150) +
                        "..."
                      : txnDetailsData?.[0]?.rejection_reason
                  }
                  isRecreateDisabled={!hasCreateService}
                  handleRecreateBtn={() => {
                    if (hasCreateService) {
                      sessionStorage.setItem(
                        "recreate_ben",
                        JSON.stringify({
                          txn_id: txnDetailsData?.txn_id,
                          type: "refactorFlow",
                        }),
                        navigate(
                          "/beneficiary_transaction_dashboard/create_beneficiary_transaction",
                          {
                            state: {
                              txn_id: txnDetailsData?.txn_id,
                              type: "refactorFlow",
                            },
                          },
                        ),
                      );
                    } else {
                      navigate("/feature_not_assigned", {
                        state: {
                          unavailableService: ["CBeneficiaryTxn"],
                        },
                      });
                    }
                  }}
                  recreateBtnNeeded={!txnDetailsData?.[0]?.refactored}
                  furtherApprovalPending={isFurtherApprovalPending}
                  approvalNotPermitted={
                    approvalNotPermitted && !isFurtherApprovalPending
                  }
                  pending={
                    txnDetailsData?.[0]?.beneficiary_account_approval_status ===
                      "approved" &&
                    txnDetailsData?.[0]?.lifecycle_status === "pending" &&
                    !approvalNotPermitted
                  }
                  rejectMobClick={() => {
                    if (!services?.includes("ABeneficiaryTxn")) {
                      navigate("/feature_not_assigned", {
                        state: { unavailableService: "ABeneficiaryTxn" },
                      });
                      return;
                    }

                    setbtnClicked((prev) => ({
                      ...prev,
                      [transactionId]: "reject",
                    }));

                    handleDeclinedDetails(transactionId);
                  }}
                  isRejectMobDisable={!checkTransaction}
                  approveMobClick={() => {
                    if (!services?.includes("ABeneficiaryTxn")) {
                      navigate("/feature_not_assigned", {
                        state: { unavailableService: "ABeneficiaryTxn" },
                      });
                      return;
                    }

                    setbtnClicked((prev) => ({
                      ...prev,
                      [transactionId]: "approve",
                    }));
                    handleApproveTransaction(transactionId);
                  }}
                  isApproveMobDisable={!checkTransaction}
                />
                <div className="flex flex-col w-width-full mt-margin-md mb-margin-base Qsmd:mb-margin-md">
                  <div className="py-padding-sm px-padding-md bg-primary-card text-font-sm text-text-primary text-left font-semibold w-width-full">
                    Quick actions
                  </div>
                  <div className="grid grid-cols-2 w-width-full bg-primary-nav border-b border-primary-bg">
                    <div className="relative">
                      <TopNavSmallButton
                        btnText={
                          <>
                            {globalText?.TRANSACTION}
                            <br />
                            {globalText?.HISTORY}
                          </>
                        }
                        btnType="button"
                        icon={ICONS?.TRANSACTION_HISTORY}
                        handleFunction={() => {
                          setIsAccName(true);
                          setIsCategoryName(false);
                          if (isTxnDetailPopup) {
                            actionRestricted();
                          } else {
                            openTransactionHistory();
                            setModalType("Transaction history");
                          }
                        }}
                        isDisabled={isTxnDetailPopup}
                        disabledBgColor="var(--primary-nav-act)"
                        enabledTextColor="var(--text-primary)"
                        enabledBgColor="var(--primary-nav-act)"
                        hoverOption="white"
                        fullWidthRequired={true}
                      />
                      <div className="absolute top-top-base right-right-base h-height-full border-r border-primary-bg"></div>
                    </div>

                    <TopNavSmallButton
                      btnText={transactionData?.category_id?.category_name}
                      btnType="button"
                      icon={categoryIcon?.url}
                      imgColor={categoryIcon?.colour}
                      isBackgroundRequired={true}
                      handleFunction={() => {
                        setIsAccName(false);
                        setIsCategoryName(true);
                        setModalType("Transaction history");

                        if (isTxnDetailPopup) {
                          actionRestricted();
                        } else {
                          openTransactionHistory();
                        }
                      }}
                      isDisabled={isTxnDetailPopup}
                      enabledTextColor="var(--text-primary)"
                      enabledBgColor="var(--primary-nav-act)"
                      disabledBgColor="var(--primary-nav-act)"
                      hoverOption="white"
                      fullWidthRequired={true}
                    />
                  </div>
                  <div
                    className={`grid w-width-full bg-primary-nav ${
                      hasConfidential &&
                      transactionData?.confidential_transaction === "Y"
                        ? "grid-cols-1"
                        : "grid-cols-1"
                    } border-b border-primary-bg`}
                  >
                    {hasConfidential &&
                      transactionData?.confidential_transaction === "Y" && (
                        <TopNavSmallButton
                          btnText={
                            <>
                              {globalText?.CONFIDENTIAL} <br />{" "}
                              {globalText?.TRANSACTION}
                            </>
                          }
                          btnType="button"
                          icon={ICONS?.CONFIDENTIAL_TRANSACTION}
                          handleFunction={() => {
                            setIsCategoryName(false);
                            setIsAccName(false);
                            if (isTxnDetailPopup) {
                              actionRestricted();
                            } else {
                              openTransactionHistory();
                              setModalType("Confidential transaction");
                            }
                          }}
                          isDisabled={isTxnDetailPopup}
                          enabledTextColor="var(--text-primary)"
                          enabledBgColor="var(--primary-nav-act)"
                          disabledBgColor="var(--primary-nav-act)"
                          hoverOption="white"
                          fullWidthRequired={true}
                        />
                      )}
                  </div>
                </div>
              </div>
            </div>
            {shouldShowBankingHoursAlert && (
              <div className="max-w-tab-width-normal w-full Qlg:mx-auto pt-padding-md px-padding-md Qlg:px-padding-base">
                <CommonAlertCard
                  title="Functioning outside banking hours"
                  texts="Transactions will be processed automatically during the next bank working day. Learn more"
                  highlightedText={["Learn more"]}
                  onHighlightedTextClick={(event, index) => {
                    if (index === 0) {
                      setShowBankingHoursPopup(true);
                    }
                  }}
                />
              </div>
            )}

            <div className="w-width-full timeline_box max-w-tab-width-normal m-auto flex items-end">
              <div
                className={`Qlg:bg-primary-card bg-inherit flex flex-col w-full lg:w-width-md mx-margin-md lg:mx-margin-base h-auto mt-margin-md overflow-hidden relative rounded-bl-border-radius-md rounded-t-border-radius-md
                   ${
                     transactionData?.distribution_lifecycle_status !==
                       "created" &&
                     txnDetailsData?.[GlobalConfiguration.lengthCheckZero]
                       ?.lifecycle_status === "rejected" &&
                     txnDetailsData?.[GlobalConfiguration.lengthCheckZero]
                       ?.lifecycle_status === "pending" &&
                     transactionData?.distribution_lifecycle_status !==
                       "distribution_complete"
                       ? "rounded-bl-border-radius-md Qlg:rounded-br-none rounded-br-border-radius-md"
                       : (txnDetailsData?.[GlobalConfiguration.lengthCheckZero]
                             ?.beneficiary_account_approval_status ===
                             "approved" &&
                             transactionData?.distribution_lifecycle_status ===
                               "created") ||
                           transactionData?.distribution_lifecycle_status ===
                             "distribution_complete" ||
                           transactionData?.distribution_lifecycle_status ===
                             "approved" ||
                           transactionData?.distribution_lifecycle_status ===
                             "awaiting_funds" ||
                           transactionData?.distribution_lifecycle_status ===
                             "distribution_initiated"
                         ? "rounded-b-border-radius-md"
                         : "rounded-bl-border-radius-md rounded-br-none"
                   }

                `}
              >
                <div
                  className={`flex flex-col w-full h-auto rounded-t-border-radius-md overflow-hidden relative ${
                    txnDetailsData?.[0]?.beneficiary_account_approval_status ===
                      "approved" &&
                    txnDetailsData?.[0].lifecycle_status === "pending"
                      ? " rounded-bl-border-radius-md  rounded-br-border-radius-md"
                      : "rounded-b-border-radius-md"
                  }`}
                >
                  {/* TITLE */}
                  <div className="pt-px bg-primary-nav rounded-tl-border-radius-md px-padding-md rounded-tr-border-radius-md">
                    <p className="text-text-primary text-font-xs text-left font-semibold my-margin-sm">
                      Transaction Timeline
                    </p>
                    <div className="border-b border-primary-bg"></div>
                  </div>

                  <div ref={leftContentRef}>
                    <CommonTimeLineCard
                      logsData={txnDetailsData}
                      handleApprovalClick={handleTimelinePopup}
                      handleDistributionClick={handleDistributionClick}
                      showApprovalTimeline={showApprovalTimeline}
                      showDistributionTimeline={showDistributionTimeline}
                      showDistributionRightIcon={true}
                      showApprovalLeftIcon={true}
                      isDisabled={isTxnDetailPopup ? true : false}
                      cardType={"double"}
                    />
                  </div>
                </div>
              </div>

              <div className="hidden lg:flex flex-col flex-grow mt-margin-md w-width-md">
                <TimelineStatusBar
                  showMobile={false}
                  isLoading={loadingBox}
                  overrideAutoLoader
                  whichBtnClicked={btnClicked?.[transactionId] || "none"}
                  requestApprove
                  approvalNotPossible={
                    networkError || errorMessage || txnDetailsData?.[0]?.message
                  }
                  approvalNotPossibleIcon={true}
                  handleApprovalNotPossibleBtn={() => {
                    if (
                      services?.includes("ABeneficiaryTxn") &&
                      checkTransaction
                    ) {
                      handleRecreateDeclinedDetails(txnDetailsData.txn_id);
                    } else {
                      navigate("/feature_not_assigned", {
                        state: {
                          unavailableService: "ABeneficiaryTxn",
                        },
                      });
                    }
                  }}
                  isApprovalNotPossibleDisabled={false}
                  accountApprovalPending={
                    txnDetailsData?.[0]?.beneficiary_account_approval_status ===
                      "pending" &&
                    txnDetailsData?.[0]?.lifecycle_status === "pending"
                  }
                  accountApprovalPendingSubHeader={
                    services?.includes("BAAccount")
                      ? "Account is not approved, approve account before approving transaction."
                      : "To approve the account, please contact the authorized person."
                  }
                  handleApprovalPendingBtn={() =>
                    services?.includes("BAAccount")
                      ? setBeneAccountDetailpop(true)
                      : navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "BAAccount",
                          },
                        })
                  }
                  isApprovalPendingDisabled={!services?.includes("BAAccount")}
                  recreate={
                    txnDetailsData?.[0]?.lifecycle_status === "rejected"
                  }
                  recreateReason={
                    txnDetailsData?.[0]?.rejection_reason?.length > 150
                      ? txnDetailsData?.[0]?.rejection_reason.slice(0, 150) +
                        "..."
                      : txnDetailsData?.[0]?.rejection_reason
                  }
                  isRecreateDisabled={!hasCreateService}
                  handleRecreateBtn={() => {
                    if (hasCreateService) {
                      sessionStorage.setItem(
                        "recreate_ben",
                        JSON.stringify({
                          txn_id: txnDetailsData?.txn_id,
                          type: "refactorFlow",
                        }),
                        navigate(
                          "/beneficiary_transaction_dashboard/create_beneficiary_transaction",
                          {
                            state: {
                              txn_id: txnDetailsData?.txn_id,
                              type: "refactorFlow",
                            },
                          },
                        ),
                      );
                    } else {
                      navigate("/feature_not_assigned", {
                        state: {
                          unavailableService: ["CBeneficiaryTxn"],
                        },
                      });
                    }
                  }}
                  recreateBtnNeeded={!txnDetailsData?.[0]?.refactored}
                  furtherApprovalPending={isFurtherApprovalPending}
                  approvalNotPermitted={
                    approvalNotPermitted && !isFurtherApprovalPending
                  }
                  pending={
                    txnDetailsData?.[0]?.beneficiary_account_approval_status ===
                      "approved" &&
                    txnDetailsData?.[0]?.lifecycle_status === "pending" &&
                    !approvalNotPermitted
                  }
                  rejectClick={() => {
                    if (!services?.includes("ABeneficiaryTxn")) {
                      navigate("/feature_not_assigned", {
                        state: { unavailableService: "ABeneficiaryTxn" },
                      });
                      return;
                    }
                    setbtnClicked((prev) => ({
                      ...prev,
                      [transactionId]: "Reject",
                    }));

                    handleDeclinedDetails(transactionId);
                  }}
                  isRejectDisable={!checkTransaction}
                  approveClick={() => {
                    if (!services?.includes("ABeneficiaryTxn")) {
                      navigate("/feature_not_assigned", {
                        state: { unavailableService: "ABeneficiaryTxn" },
                      });
                      return;
                    }

                    setbtnClicked((prev) => ({
                      ...prev,
                      [transactionId]: "Approve",
                    }));
                    handleApproveTransaction(transactionId);
                  }}
                  isApproveDisable={!checkTransaction}
                />
              </div>
            </div>

            <div
              className={`details-div-trans lg:mb-margin-md bg-primary-bg pt-padding-sm lg:pt-padding-base pb-padding-xl ${
                isTxnDetailPopup ? "w-width-full" : "w-screen"
              }`}
            >
              <div className="detail-section-trans h-auto bg-primary-bg m-auto max-w-tab-width-normal">
                <div className="mt-margin-sm Qsmd:mt-margin-md flex">
                  <div className="flex gap-gap-sm bg-primary-card w-auto ml-margin-md lg:ml-margin-base rounded-border-radius-md overflow-x-auto">
                    <SwitcherTabs
                      initialActiveTab={
                        showAssignedLabels
                          ? "Assigned Labels"
                          : showAdditionalDetails
                            ? "Additional details"
                            : "details"
                      }
                      tabs={[
                        {
                          label: "Details",
                          key: "details",
                          handler: toggleDetails,
                        },
                        {
                          label: "Additional details",
                          key: "Additional details",
                          handler: toggleAdditionalDetails,
                        },
                        {
                          label: "Labels",
                          key: "Assigned Labels",
                          handler: toggleAssignedLabels,
                        },
                      ]}
                      setIndex={setIndex}
                    />
                  </div>
                </div>
                <div className="relative">
                  {index === GlobalConfiguration?.lengthCheckZero && (
                    <div className={animationClass}>
                      {txnDetailsData?.map((account) => {
                        let originItemList = [
                          {
                            content: `${account?.logs?.[0]?.first_name ?? ""} ${account?.logs?.[0]?.last_name ?? ""}`,
                            heading: "Created by",
                            type: "text",
                          },
                          {
                            content: formatDateViewAll(
                              account?.created_on,
                              true,
                              true,
                            ),
                            heading: "Created on",
                            type: "text",
                          },
                        ];
                        if (account?.created_via) {
                          originItemList.push({
                            content: account?.created_via ?? "",
                            heading: "Created via",
                            type: "text",
                          });
                        }

                        const settlementItemList =
                          account?.distribution_settlement_id
                            ? [
                                {
                                  content: account.distribution_credited_at
                                    ? ISO_DataFormatter(
                                        account.distribution_credited_at,
                                      )
                                    : "N/A",
                                  heading: "Settled on",
                                  type: "text",
                                },
                                {
                                  content: account.distribution_settlement_id,
                                  heading: "Settlement ID",
                                  type: "textWithButton",
                                  iconArray: [
                                    {
                                      icon:
                                        copiedField === "settlement_id"
                                          ? ICONS.SELECTED_WITH_GREEN_CIRCLE
                                          : ICONS.COPY,
                                      bgColor: "var(--text-primary)",
                                      title:
                                        copiedField === "settlement_id"
                                          ? "Copied"
                                          : "Copy to clipboard",
                                      onClick: () => {
                                        setCopiedField("settlement_id");
                                        navigator.clipboard.writeText(
                                          account.distribution_settlement_id,
                                        );

                                        setTimeout(() => {
                                          setCopiedField("");
                                        }, IntervalConfiguration.intervalMedium);
                                      },
                                    },
                                  ],
                                },
                              ]
                            : [];

                        let supportItemList = [
                          {
                            content: account.txn_id,
                            heading: "Transaction ID",
                            type: "textWithButton",
                            iconArray: [
                              {
                                icon:
                                  copiedField === "txn_id"
                                    ? ICONS.SELECTED_WITH_GREEN_CIRCLE
                                    : ICONS.COPY,
                                bgColor: "var(--text-primary)",
                                title:
                                  copiedField === "txn_id"
                                    ? "Copied"
                                    : "Copy to clipboard",
                                onClick: (e) => {
                                  setCopiedField("txn_id");
                                  navigator.clipboard.writeText(account.txn_id);

                                  setTimeout(() => {
                                    setCopiedField("");
                                  }, IntervalConfiguration.intervalMedium);
                                },
                              },
                            ],
                          },

                          ...(account?.distribution_id
                            ? [
                                {
                                  content: account.distribution_id,
                                  heading: "Distribution ID",
                                  type: "textWithButton",
                                  iconArray: [
                                    {
                                      icon:
                                        copiedField === "distribution_id"
                                          ? ICONS.SELECTED_WITH_GREEN_CIRCLE
                                          : ICONS.COPY,
                                      bgColor: "var(--text-primary)",
                                      title:
                                        copiedField === "distribution_id"
                                          ? "Copied"
                                          : "Copy to clipboard",
                                      onClick: (e) => {
                                        setCopiedField("distribution_id");
                                        navigator.clipboard.writeText(
                                          account.distribution_id,
                                        );

                                        setTimeout(() => {
                                          setCopiedField("");
                                        }, IntervalConfiguration.intervalMedium);
                                      },
                                    },
                                  ],
                                },
                              ]
                            : []),

                          ...(account?.distribution_identifier
                            ? [
                                {
                                  content: account.distribution_identifier,
                                  heading: "Distribution identifier",
                                  type: "textWithButton",
                                  iconArray: [
                                    {
                                      icon:
                                        copiedField ===
                                        "distribution_identifier"
                                          ? ICONS.SELECTED_WITH_GREEN_CIRCLE
                                          : ICONS.COPY,
                                      bgColor: "var(--text-primary)",
                                      title:
                                        copiedField ===
                                        "distribution_identifier"
                                          ? "Copied"
                                          : "Copy to clipboard",
                                      onClick: (e) => {
                                        setCopiedField(
                                          "distribution_identifier",
                                        );
                                        navigator.clipboard.writeText(
                                          account.distribution_identifier,
                                        );
                                        setTimeout(() => {
                                          setCopiedField("");
                                        }, IntervalConfiguration.intervalMedium);
                                      },
                                    },
                                  ],
                                },
                              ]
                            : []),
                        ];
                        return (
                          <div
                            className={`flex flex-col lg:flex-row my-margin-md px-padding-md lg:px-padding-base ${
                              account?.distribution_lifecycle_status ===
                              "distribution_complete"
                                ? "justify-between gap-gap-md"
                                : "gap-gap-md lg:gap-gap-md"
                            }`}
                          >
                            <CommonDetailCard
                              cardTitle={globalText?.ORIGIN_DETAILS}
                              variant="third"
                              numCols={GlobalConfiguration?.lengthCheckOne}
                              entries={originItemList}
                            />
                            {account?.distribution_lifecycle_status ===
                              "distribution_complete" && (
                              <CommonDetailCard
                                cardTitle={globalText?.SETTLEMENT_DETAILS}
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                variant="third"
                                entries={settlementItemList}
                              />
                            )}
                            <CommonDetailCard
                              cardTitle={globalText?.SUPPORT_INFORMATION}
                              numCols={GlobalConfiguration?.lengthCheckOne}
                              variant="third"
                              entries={supportItemList}
                            />
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {index === GlobalConfiguration?.lengthCheckOne && (
                    <div className={animationClass}>
                      <div className="flex flex-col lg:flex-row items-start gap-gap-md pb-padding-md text-text-primary mt-margin-md px-padding-md lg:px-padding-base">
                        <>
                          {validItems?.filter(
                            (item) =>
                              item.name !== "Hyperlink" &&
                              item.name !== "File" &&
                              item.name !== "Image",
                          ).length === GlobalConfiguration?.lengthCheckZero ? (
                            <div className="w-details-card-md flex flex-col p-padding-md gap-gap-md bg-primary-card rounded-border-radius-md">
                              <div className="text-text-primary text-font-sm font-semibold">
                                {globalText?.ADDITIONAL_DETAILS}
                              </div>
                              <p className="text-text-secondary text-font-xs font-normal">
                                Additional details are not supported for the
                                selected category.
                              </p>
                            </div>
                          ) : (
                            <>
                              {(() => {
                                const filteredItems = validItems.filter(
                                  (item) =>
                                    item.data_type.toLowerCase() !==
                                      "hyperlink" &&
                                    item.data_type !== "File" &&
                                    item.data_type !== "Image" &&
                                    item.data_type !== "upload",
                                );

                                return (
                                  <>
                                    {!!filteredItems.length && (
                                      <CommonDetailCard
                                        cardTitle={
                                          globalText?.ADDITIONAL_DETAILS
                                        }
                                        numCols={
                                          filteredItems.length ===
                                          GlobalConfiguration?.lengthCheckOne
                                            ? GlobalConfiguration?.lengthCheckOne
                                            : GlobalConfiguration?.lengthCheckTwo
                                        }
                                        variant="third"
                                        entries={filteredItems.map(
                                          (subItem, index) => {
                                            switch (subItem.data_type) {
                                              case "toggle":
                                                return {
                                                  content: subItem?.value
                                                    ? "Yes"
                                                    : "No",
                                                  heading: subItem?.name,
                                                  type: "text",
                                                };
                                              case "multi_select_list":
                                                return {
                                                  content:
                                                    subItem?.value?.length !==
                                                    GlobalConfiguration?.lengthCheckZero
                                                      ? subItem?.value?.join(
                                                          ", ",
                                                        )
                                                      : "Not given",
                                                  heading: subItem?.name,
                                                  type: "text",
                                                };
                                              case "date_range":
                                                return {
                                                  content: subItem?.value
                                                    ?.start_date
                                                    ? `${subItem.value.start_date} - ${subItem.value.end_date}`
                                                    : "Not given",
                                                  heading:
                                                    "From date - To date",
                                                  type: "text",
                                                };
                                              case "from_year_to_year":
                                                return {
                                                  content: subItem?.value?.from
                                                    ? `${subItem.value.from} - ${subItem.value.to}`
                                                    : "Not given",
                                                  heading:
                                                    "From year - To year",
                                                  type: "text",
                                                };
                                              default:
                                                return {
                                                  content:
                                                    subItem?.value ??
                                                    "Not given",
                                                  heading: subItem?.name,
                                                  type: "text",
                                                  onClick: undefined,
                                                };
                                            }
                                          },
                                        )}
                                      />
                                    )}
                                  </>
                                );
                              })()}
                            </>
                          )}
                        </>

                        {attachments.length >
                          GlobalConfiguration?.lengthCheckZero && (
                          <>
                            <CommonDetailCard
                              cardTitle={globalText?.ATTACHMENTS}
                              numCols={GlobalConfiguration?.lengthCheckOne}
                              variant="third"
                              entries={attachments.map((obj, index) => {
                                switch (obj.data_type.toLowerCase()) {
                                  case "hyperlink":
                                    return {
                                      content: obj?.value ?? "#",
                                      heading: "URL",
                                      type: "link",
                                    };
                                  default: {
                                    let ob = obj.value;
                                    const mt =
                                      ob?.metadata?.mime_type ??
                                      "application/octet-stream";
                                    switch (true) {
                                      case mt?.startsWith("image/"):
                                        return {
                                          content: {
                                            fileName: ob?.metadata?.filename,
                                            size: ob?.metadata?.size ?? "0",
                                            mimeType: mt,
                                            url: ob?.file_url,
                                            onUrlClick: () => {
                                              setOpenImageUrl(true);
                                              setSelectedImage({
                                                name: ob?.metadata?.filename,
                                                url: ob?.file_url,
                                              });
                                            },
                                          },
                                          heading: "Image",
                                          type: "image",
                                        };
                                      default:
                                        return {
                                          content: {
                                            fileName: ob?.metadata?.filename,
                                            size: ob?.metadata?.size ?? "0",
                                            mimeType: mt,
                                            onUrlClick: () => {
                                              window
                                                .open(ob?.file_url, "_blank")
                                                .focus();
                                            },

                                            url: ob?.file_url,
                                          },
                                          heading: "File",
                                          type: "file",
                                        };
                                    }
                                  }
                                }
                              })}
                            />
                          </>
                        )}
                      </div>
                    </div>
                  )}

                  {index === GlobalConfiguration?.lengthCheckTwo && (
                    <div className={animationClass}>
                      <div className="mt-margin-md">
                        <CommonContainerCard
                          header="Labels"
                          iconIsDisabled={
                            !(
                              services?.includes("ALabel") &&
                              services?.includes("RLabel")
                            ) || isTxnDetailPopup
                          }
                          subheader={globalText?.LABELS_USAGE_NOTE}
                          icon={ICONS?.EDIT}
                          handleFunction={(e) => {
                            e.stopPropagation();

                            if (!(
                              services?.includes("ALabel") &&
                              services?.includes("RLabel")
                            )) {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "ALabel,RLabel",
                                },
                              });
                              return;
                            }

                            if (isTxnDetailPopup) {
                              actionRestricted();
                              return;
                            }

                            setShowLabelsPopup(true);
                          }}
                        >
                          <div className="flex flex-wrap w-width-full gap-gap-sm overflow-x-auto">
                            {Array.isArray(labelDetails) &&
                            labelDetails.length ? (
                              <>
                                {labelDetails.map((item, index) => (
                                  <Chips
                                    key={index}
                                    txtChip={item}
                                    enabledBgColor="var(--primary-nav)"
                                    disableIcon={true}
                                    handleFunction={(e) => {
                                      e.stopPropagation();
                                      return;
                                    }}
                                    enabledTextColor="var(--text-primary)"
                                  />
                                ))}
                              </>
                            ) : (
                              <p className="text-font-sm text-text-primary">
                                No labels assigned.
                              </p>
                            )}
                          </div>
                        </CommonContainerCard>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default BeneficiaryTransactionDetails;
